export default {"src":"/_next/static/media/outdoor-shower.af31c88b.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};